
import Vue from "vue";
import { NewCompaniesApiFunc, setAccessToken } from "@/api";
import { Company } from "@/models";

import TheTemplate from "../components/TheNoSidebarTemplate.vue";
import CompanyEditor from "./components/CompanyEditor.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";

export type DataType = {
  company?: Company;
};

export default Vue.extend({
  name: "CompanyDetailScreen",

  components: {
    TheTemplate,
    CompanyEditor,
    BaseCloseButton,
  },

  data(): DataType {
    return {
      company: undefined,
    };
  },

  mounted(): void {
    this.getCompany();
  },

  methods: {
    async getCompany(): Promise<void> {
      const companyId = this.$router.currentRoute.params.companyId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewCompaniesApiFunc().adminGetCompany(
        companyId
      );

      if (err != null) {
        this.$handleApiError(err, this.getCompany);
        return;
      }

      this.company = data;
    },

    async updateCompany(company: Company): Promise<void> {
      this.$setLoading(true);
      const companyId = this.$router.currentRoute.params.companyId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewCompaniesApiFunc().adminUpdateCompany(
        companyId,
        company
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.updateCompany(company);
        });
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "admin-companies",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
